import { render, staticRenderFns } from "./NewFields.vue?vue&type=template&id=382d52c7"
import script from "./NewFields.vue?vue&type=script&lang=js"
export * from "./NewFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports